import React from 'react';
import Pagination from './Pagination';

const PaginationControls = ({
    currentPage,
    totalPages,
    setCurrentPage,
    itemsPerPage,
    setItemsPerPage,
    totalItems,
}) => {
    const indexOfFirst = totalItems === 0 ? 0 : (currentPage - 1) * itemsPerPage + 1;
    const indexOfLast = Math.min(currentPage * itemsPerPage, totalItems);

    return (
        <>
            <div className="d-flex justify-content-between align-items-center mt-3">
                <div className="d-flex align-items-center">
                    <span className="me-2">Items per page:</span>
                    <select
                        className="form-select form-select-sm"
                        style={{ width: "70px" }}
                        value={itemsPerPage}
                        onChange={(e) => {
                            setItemsPerPage(parseInt(e.target.value));
                            setCurrentPage(1);
                        }}
                    >
                        <option value={5}>5</option>
                        <option value={10}>10</option>
                        <option value={25}>25</option>
                        <option value={50}>50</option>
                    </select>
                </div>
                <div className="d-flex justify-content-end">
                    <Pagination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        setCurrentPage={setCurrentPage}
                    />
                </div>
            </div>
            <div className="text-center text-muted mt-3">
                <small>
                    {totalItems > 0
                        ? `Showing ${indexOfFirst} to ${indexOfLast} of ${totalItems} entries`
                        : 'No entries to display'}
                </small>
            </div>
        </>
    );
};

export default PaginationControls;
